import {useTheme} from '@mui/material/styles';

import SearchIcon from 'components/icons/search.svg';
import {Placeholder, PlaceholderProps} from 'components/Placeholder';

/**
 * Preferably for autocompletes
 */
export function NothingFoundPlaceholder(
  props: Omit<PlaceholderProps, 'heading'> & Partial<Pick<PlaceholderProps, 'heading'>>
) {
  const theme = useTheme();

  return (
    <Placeholder
      icon={<SearchIcon width={48} height={48} color={theme.palette.text.secondary} />}
      heading='Nothing Found'
      subheading='It seems we can’t find what you’re looking for'
      {...props}
    />
  );
}
